import type { IconProps } from '../types/IconProps.ts';
export const Infinity: IconProps = {
    name: 'Infinity',
    children: [
        `<path d="M12 12 7.73 8.73C5.32 6.88 2 8.77 2 12s3.08 4.97 5.5 3.12zm0 0 4.5-3.27C18.92 6.88 22 8.77 22 12s-3.32 5.12-5.73 3.27z" />`,
    ]
};